import { Button, Popover, Image } from 'antd';
import { ZoomInOutlined } from '@ant-design/icons';
import * as React from 'react';

interface Props {
    title: string;
    handleClick: () => void;
    thumbnail?: string;
}

const Suggestion = (props: Props) => {
    return (
        <div className={'suggestion flex flex-row justify-start items-center'}>
            <Button className=" space-x-0.5 text-xs mt-0 mr-2" type="dashed" size="small" onClick={props.handleClick}>
                <div className={'font-normal'} title={`${props.title}`}>
                    {props.title.substring(0, 8)}...
                </div>
            </Button>
            {props.thumbnail && (
                <Popover
                    title={
                        <div className={'flex flex-row justify-start'}>
                            <div className={'font-bold'}>Suggested Option: </div>
                            <div className={'font-normal ml-2'}>{props.title}</div>
                        </div>
                    }
                    placement="right"
                    content={
                        <div
                            className={'border'}
                            style={{
                                maxWidth: 500,
                                background: '#d4d4d4',
                                textAlign: 'center',
                            }}
                        >
                            <Image
                                preview={false}
                                style={{
                                    maxWidth: '90%',
                                    margin: 'auto',
                                }}
                                src={props.thumbnail}
                            />
                        </div>
                    }
                >
                    <ZoomInOutlined />
                </Popover>
            )}
        </div>
    );
};

export default Suggestion;
